import React from 'react';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { CurrencyField, DataTable, Field } from '../../../commons/DataTable';
import { ContAffiliation, H5Styled } from '../../../styled-components';
import SummaryTotalRow from './SummaryTotalRow';

function SummaryTable({ title, rows = [] }) {
  const [t] = useTranslation();
  const total = rows.reduce((acc, row) => acc + Number(row?.total || 0), 0);
  const totalToEmit = rows.reduce(
    (acc, row) => acc + Number(row?.toEmit || 0),
    0
  );

  return (
    <ContAffiliation>
      <Row>
        <Col xs="12">
          <H5Styled>{title}</H5Styled>
        </Col>
      </Row>
      <DataTable
        data={rows}
        total={rows.length}
        offset={0}
        limit={rows.length || 1}
        onFilter={() => {}}
        emptyText={t('COMMON:NO_DATA')}
        tableFixed
        bottomRow={<SummaryTotalRow total={total} toEmit={totalToEmit} />}
      >
        <Field title="Servizio" source="service" />
        <CurrencyField
          title="Quota da Incassare"
          source="total"
          className="txt-table-right"
        />
        <CurrencyField
          title="Quota da Emettere"
          source="toEmit"
          className="txt-table-right"
        />
      </DataTable>
    </ContAffiliation>
  );
}

export default SummaryTable;
